import { render, staticRenderFns } from "./MediaMix.vue?vue&type=template&id=62d71880&"
import script from "./MediaMix.vue?vue&type=script&lang=js&"
export * from "./MediaMix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports